import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { defaultSubmitNoteIntent, planSubmitNoteIntent } from "utils/helpers/noteSubmit";

const SubmitNoteIntentContext = createContext(null);

export const SubmitNoteIntentProvider = ({ children, isDemo = false }) => {
	const [intent, setIntent] = useState(defaultSubmitNoteIntent);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [directSubmitNonce, setDirectSubmitNonce] = useState(0);

	const requestNoteSubmit = useCallback((submitIntent = planSubmitNoteIntent) => {
		setIntent(submitIntent);
		setDirectSubmitNonce((nonce) => nonce + 1);
	}, []);

	const value = useMemo(
		() => ({
			intent,
			setIntent,
			isDemo,
			isSubmitting,
			setIsSubmitting,
			directSubmitNonce,
			requestNoteSubmit,
		}),
		[intent, isDemo, isSubmitting, directSubmitNonce, requestNoteSubmit]
	);

	return <SubmitNoteIntentContext.Provider value={value}>{children}</SubmitNoteIntentContext.Provider>;
};

export const useSubmitNoteIntent = () => {
	const context = useContext(SubmitNoteIntentContext);
	if (!context) {
		throw new Error("useSubmitNoteIntent must be used within SubmitNoteIntentProvider");
	}
	return context;
};
